import { Agent } from '../types/agent';

export const agents: Agent[] = [
  {
    id: 'julia',
    name: 'Julia',
    role: 'Eye Catching Media Customer Support',
    avatarUrl: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400',
    email: 'support@eye-catchingmedia.com',
    yearsAtCompany: 4,
    bio: "I've been with Eye Catching Media for 4 years, specializing in helping customers find the perfect digital signage solutions. I have a background in visual merchandising and love to help businesses create eye-catching displays that drive engagement. In my free time, I enjoy photography and interior design."
  },
  {
    id: 'tom',
    name: 'Tom',
    role: 'Eye Catching Media Customer Support',
    avatarUrl: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=400',
    email: 'support@eye-catchingmedia.com',
    yearsAtCompany: 2,
    bio: "I joined Eye Catching Media 2 years ago after working in retail technology. I'm passionate about helping customers understand the technical aspects of our products and finding solutions that meet their specific needs. I have a degree in Computer Science and enjoy troubleshooting complex issues. When I'm not helping customers, I'm an avid rock climber and coffee enthusiast."
  },
  {
    id: 'petra',
    name: 'Petra',
    role: 'Eye Catching Media Customer Support',
    avatarUrl: 'https://images.unsplash.com/photo-1534751516642-a1af1ef26a56?w=400',
    email: 'support@eye-catchingmedia.com',
    yearsAtCompany: 5,
    bio: "With 5 years at Eye Catching Media, I've helped hundreds of clients transform their spaces with our innovative display solutions. I specialize in retail and corporate environments and love seeing how our products enhance customer experiences. I have a background in marketing and design, which helps me understand both the aesthetic and strategic needs of our clients. Outside of work, I enjoy traveling and exploring new restaurants."
  }
];

export function getRandomAgent(): Agent {
  const randomIndex = Math.floor(Math.random() * agents.length);
  return agents[randomIndex];
}

export function getAgentById(id: string): Agent {
  return agents.find(agent => agent.id === id) || agents[0];
}